'use client'

import { MyButton, ToWeb } from './myButton'
import { toWeb } from './util'
import './index.css';
import PopupWrapper from './components/PopupWrapper';
export default function Head() {
  return (
    <>
      <section className="flex flex-col relative items-center overflow-visible relative w-screen h-screen bg-cover" id="head1" style={{ background: `url(${process.env.PUBLIC_URL}/images/page1_bg.png) 100% 100% no-repeat` }}>
        <div className="  flex items-center flex-col overflow-visible">
          <div className="h-[239px] " ></div>
          <div className={`text-white font-normal font-medium text-3xl leading-12 `} >
            让游戏连接彼此
          </div>
          <div className="h-48px"></div>
          <div className="flex items-center flex-row overflow-visible" style={{ zIndex: 9 }}>
            <PopupWrapper child={<MyButton onClick></MyButton>} />
            <div className="w-[56px]"></div>
            <ToWeb onClick={toWeb}></ToWeb>
          </div>
        </div>
        <div className="h-[25px]"></div>
      </section>
    </>
  )
}